import React from 'react'
import { useDispatch } from 'react-redux'
import E3DLogoutModal from './E3DLogoutModal'
import { logout } from '../../../redux/actions/app/e3DGrpAuth.actions'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const E3DLogoutModalContainer: React.FC<Props> = ({ isOpen, onClose }) => {
  const dispatch = useDispatch()

  const handleConfirmLogout = () => {
    dispatch(logout())
    onClose()
  }

  return (
    <E3DLogoutModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirmLogout}
    />
  )
}

export default E3DLogoutModalContainer
